const steps = [
  { text: 'Choose a product category.', icon: 'ri-list-check' },
  { text: 'Open the relevant spreadsheet resource.', icon: 'ri-file-list-line' },
  { text: 'Compare products and sellers.', icon: 'ri-arrow-left-right-line' },
  { text: 'Review QC information and seller details.', icon: 'ri-image-line' },
  { text: 'Check shipping information before ordering.', icon: 'ri-truck-line' },
  { text: 'Continue to the main website when you are ready.', icon: 'ri-external-link-line' },
];

export default function HowToSteps() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">Process</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950">
            How to Use the AllChinaBuy Spreadsheet
          </h2>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
            {steps.map((step, idx) => (
              <div key={idx} className="relative text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500 text-white text-lg font-bold mb-4">
                  {idx + 1}
                </div>
                <i className={`${step.icon} text-2xl text-primary-600 mb-3`} />
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {step.text}
                </p>
                {idx < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-6 left-[calc(100%-12px)] w-[calc(100%+24px)] h-0.5 bg-primary-200" />
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors"
          >
            Buy It Now
            <i className="ri-external-link-line" />
          </a>
        </div>
      </div>
    </section>
  );
}